import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

const Privacy: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h2" sx={{ mb: 2 }}>Privacy Policy</Typography>
      <Typography variant="subtitle2" sx={{ mb: 4, color: 'text.secondary' }}>Effective Date: 13-01-2025</Typography>

      <Typography paragraph>At Amrutha Kalasam, we value your privacy and are committed to protecting your personal information. This privacy policy explains how we collect, use, and protect the data you provide when using our website and services.</Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>1. Information We Collect</Typography>
        <Typography component="div" sx={{ mb: 2 }}>
          <ul style={{ marginTop: 0, paddingLeft: '1.2rem' }}>
            <li><strong>Personal Information:</strong> Name, email address, phone number, address, and other details you provide when making a booking or enquiry.</li>
            <li><strong>Non-personal Information:</strong> Website usage data such as your IP address, browser type, and access times.</li>
          </ul>
        </Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>2. How We Use Your Information</Typography>
        <Typography component="div" sx={{ mb: 2 }}>
          <ul style={{ marginTop: 0, paddingLeft: '1.2rem' }}>
            <li>Processing bookings and providing services.</li>
            <li>Communicating with you regarding your bookings, enquiries, and promotions.</li>
            <li>Improving our website and services.</li>
            <li>Legal and compliance purposes.</li>
          </ul>
        </Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>3. Data Security</Typography>
        <Typography paragraph>We take the security of your personal information seriously. We implement reasonable security measures to protect your data from unauthorized access, alteration, disclosure, or destruction.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>4. Sharing Your Information</Typography>
        <Typography paragraph>We will not sell, rent, or share your personal information with third parties except as required by law or necessary for providing our services. This includes sharing information with third-party payment processors for payment processing and service delivery.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>5. Cookies</Typography>
        <Typography paragraph>Our website uses cookies to enhance your browsing experience. Cookies are small files stored on your device that help us remember your preferences and improve the website’s functionality.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>6. Your Rights</Typography>
        <Typography paragraph>You have the right to access, update, or delete your personal information. If you wish to exercise any of these rights, please contact us at: <strong>amruthakalasamastrology@gmail.com</strong>.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>7. Changes to this Privacy Policy</Typography>
        <Typography paragraph>We may update this privacy policy from time to time. Any changes will be posted on this page with the updated date.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>8. Contact Information</Typography>
        <Typography paragraph>If you have any questions or concerns about our privacy practices, please contact us at:</Typography>
        <Typography paragraph>Email: amruthakalasamastrology@gmail.com</Typography>
        <Typography paragraph>Address: 337 1, Huda Sai Nagar Community Hall, H No 5 4, Kamala Nagar Rd, Near Kamal Nagar, Kamala Nagar, Hyderabad, Telangana-500070</Typography>
      </Box>

      <Divider sx={{ my: 6 }} />
      <Typography variant="body2" color="text.secondary">
        © 2024 Amruthakalasam. All rights reserved.
      </Typography>
    </Container>
  );
};

export default Privacy;
